// extracted by mini-css-extract-plugin
export const sectionSpacing = "header-module--section-spacing--1XiYf";
export const rowSpacing = "header-module--row-spacing--3edmy";
export const rowSpacingSml = "header-module--row-spacing-sml--2-_2L";
export const header = "header-module--header--71s3a";
export const normalLogo = "header-module--normalLogo--1f1IQ";
export const normalBlob = "header-module--normalBlob--37oEM";
export const mobileBlob = "header-module--mobileBlob--NRRHO";